import { useAppState } from "./context";

/**
 * Get a translatable string.
 */
export const i18n = (slug, context = null) => {
  if (context) {
    slug = `${context}.${slug}`;
  }

  return window.WPMailPro.strings[slug] ? window.WPMailPro.strings[slug] : "";
};

/**
 * Get a specific field value coming from the database.
 */
export const getField = (name, defaultValue = "") => {
  return window.WPMailPro.data.fields[name]
    ? window.WPMailPro.data.fields[name]
    : defaultValue;
};
